import React from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import "./TopPage.css"

function TopPage() {
  const navigate = useNavigate()
  const toPostpage = () =>{
    navigate('/Post')
  }
  return (
    <div className='TopPage'>
      <div className='toppage-top'>
        <div className='toppage-hero'>
            <h3 className='toppage-title'>
                お気に入りの <br />
                旅行先を <br />
                シェアしよう
            </h3>
            <button className='toppage-button' onClick={toPostpage}>
                始める
            </button>
        </div>
        <div className='toppage-img'>
        <img src="./images/cat.trip.png" width={600} height={600}/>
        </div>
      </div>
    </div>
  )
}

export default TopPage